export default __webpack_public_path__ + "static/media/raiffeisen_background_xl2.5aaced20.jpg";